/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { use, useCallback, useEffect } from 'fierry/react';

import * as Util from 'solis/navigation/util';


const PopStateListener = (event, client, dispatch) =>
{
  const history = event.state?.history ?? Util.getInitialHistory();

  dispatch.reconcile({ history });
};


export default ({ ClientContext, DispatchContext }) =>
{
  const client = use(ClientContext);
  const dispatch = use(DispatchContext);

  const onPopState = useCallback(PopStateListener, [ client, dispatch ]);

  const effectCallback = () =>
  {
    window.addEventListener('popstate', onPopState);

    return () =>
    {
      window.removeEventListener('popstate', onPopState);
    }
  };

  return useEffect(effectCallback, []);
}
